


<div class="controller-card" id="container">
    <button class="close-button" (click)="modalClose()" >✕</button>
  
    <header class="controller-header">
      <div class="controller-avatar">
        <img [src]="profileImage" alt="Controller Icon" class="profile-photo"/>
      </div>
      <h2>{{userDetailsInfo?.firstname}} {{userDetailsInfo?.lastname}}</h2>
    </header>


  
    <div class="controller-info" >
      <div class="info-row">
        <img src="assets/img/location.svg" alt="Model Icon" />
        <div class="info-text">
          <span class="label">Timezone</span>
          <p class="value">{{userDetailsInfo?.timezone}}</p>
          
        </div>
      </div>
  
      <div class="info-row">
        <img src="assets/img/home.svg" alt="Serial Icon" />
        <div class="info-text">
          <span class="label">Address</span>
          <p class="value">{{userDetailsInfo?.street_address1}} {{userDetailsInfo?.state}}</p>
          <span class="label-zip-code">{{userDetailsInfo?.zip_code}}</span> 
        </div>
      </div>
  
      <div class="info-row">
        <img src="assets/img/email.svg" alt="Serial Icon" />
        <div class="info-text">
          <span class="label">Email</span>
          <p class="value"><a class="value" href="mailto:{{userDetailsInfo?.username}}">{{userDetailsInfo?.username}} </a></p>
        </div>
      </div>
  
   
  
      <div class="info-row">
        <img src="assets/img/phone.svg" alt="Date Icon" />
        <div class="info-text">
          <span class="label">Phone</span>
          <p class="value">{{userDetailsInfo?.phone_number}} </p>
        </div>
      </div>
  
    </div>
  
  